//#region src/errors/not-found.ts
var e = class extends Error {
	constructor(e) {
		super(e?.error.message), this.name = this.constructor.name;
	}
	static isNotFoundResponse(e) {
		return !(!e || typeof e != "object" || !("error" in e) || !e.error || typeof e.error != "object" || !("code" in e.error) || !("message" in e.error));
	}
};
//#endregion
export { e as NotFound };
